import { render, staticRenderFns } from "./MobileLayout.vue?vue&type=template&id=e31efa72&scoped=true"
import script from "./MobileLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobileLayout.vue?vue&type=style&index=0&id=e31efa72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31efa72",
  null
  
)

export default component.exports